<template>
    <div :class="$style.container">
        <div :class="['custom-scroll', $style.treeContainer]">
            <SearchTree />
        </div>

        <div :class="$style.productsContainer">
            <div :class="['custom-scroll', $style.productsHeader]">
                <div data-code="article">Артикул</div>
                <div v-if="defaults.showCodeColumn" data-code="article">Код</div>
                <div v-if="!features.includes('no-additional-information-in-search')" data-code="show-info"></div>
                <div data-code="name">Наименование</div>
                <div data-code="count">Кол-во</div>
                <div data-code="measure">Ед. изм.</div>
                <div data-code="price">Цена</div>
                <div data-code="append-button"></div>
            </div>
            <div :class="['custom-scroll', $style.products]" ref="results" @scroll="onResultScroll">
                <SearchResultsItem 
                    v-for="(item, index) in searchResult"
                    :key="index"
                    :item="item"
                />

                <div :class="[$style.preloader, {[$style.preloader_showed]: isSearchingProducts}]">
                    <SearchResultsItemPreload :nameLength="200" />
                    <SearchResultsItemPreload :nameLength="100" />
                    <SearchResultsItemPreload :nameLength="150" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

import SearchTree from '../SearchTree/SearchTree';
import SearchResultsItem from '../SearchResultsItem/SearchResultsItem';
import SearchResultsItemPreload from '../SearchResultsItem/SearchResultsItemPreload';

export default {
    data(){
        return {
            scrollBottomOffset: 50, // отступ в пикселях от нижней границы, когда нужно запускать подгрузку следующей страницы
        }
    },
    computed: {
        ...mapGetters({
            defaults: 'settings/defaults'
        }),
        features() {
            return this.$store.getters['features/getFeatures'];
        },
        searchResult(){
            return this.$store.getters['products/searchResult'];
        },
        isSearchingProducts(){
            return this.$store.getters['products/isSearching'];
        },
    },
    methods: {
        onResultScroll(e){
            const containerHeight = e.target.clientHeight;
            const height = e.target.scrollHeight;
            const top = e.target.scrollTop;
            const bottom = height - (containerHeight + top);

            const isNeedLoadNextPage = bottom < this.scrollBottomOffset && !this.isSearchingProducts;

            if(isNeedLoadNextPage){
                this.$store.dispatch('products/searchNextPage');
            }
        },
    },
    components: {
        SearchTree,
        SearchResultsItem,
        SearchResultsItemPreload,
    }
}
</script>


<style lang="scss" module>
    @import './SearchResults.scss';
</style>